<template>
  <div class="aroma-vital-chart">
    <div v-if="series" class="aroma-vital-chart__grid">
      <section class="aroma-vital-chart__panel">
        <h3>心率趋势</h3>
        <div ref="heartChart" class="aroma-vital-chart__canvas" role="img" aria-label="心率趋势图"></div>
      </section>
      <section class="aroma-vital-chart__panel">
        <h3>呼吸趋势</h3>
        <div ref="breathingChart" class="aroma-vital-chart__canvas" role="img" aria-label="呼吸频率趋势图"></div>
      </section>
    </div>
    <van-empty v-else description="暂无心率和呼吸趋势数据" image-size="72"></van-empty>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'AromaVitalChart',

  props: {
    series: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      heartChartInstance: null,
      breathingChartInstance: null
    }
  },

  watch: {
    series: {
      deep: true,
      handler () {
        this.$nextTick(this.renderChart)
      }
    }
  },

  mounted () {
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
    this.disposeCharts()
  },

  methods: {
    chartOption (name, color, data) {
      return {
        animationDuration: 240,
        color: [color],
        grid: { left: 8, right: 24, top: 34, bottom: 58, containLabel: true },
        tooltip: {
          trigger: 'axis',
          confine: true,
          valueFormatter: value => value === null || value === undefined ? '--' : `${value}次/分`
        },
        dataZoom: [
          { type: 'inside', xAxisIndex: 0, filterMode: 'none' },
          { type: 'slider', xAxisIndex: 0, height: 16, bottom: 8, filterMode: 'none', showDetail: false }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.series.labels,
          axisLine: { lineStyle: { color: '#dce8f2' } },
          axisTick: { show: false },
          axisLabel: {
            color: '#8f959e',
            fontSize: 10,
            hideOverlap: true,
            margin: 10,
            showMinLabel: true,
            showMaxLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '次/分',
          nameGap: 8,
          nameTextStyle: { color: '#8f959e', fontSize: 10 },
          axisLabel: { color: '#8f959e', fontSize: 10 },
          splitLine: { lineStyle: { color: '#edf0f5' } }
        },
        series: [
          {
            name,
            type: 'line',
            smooth: true,
            showSymbol: false,
            connectNulls: false,
            lineStyle: { width: 2 },
            areaStyle: { opacity: 0.08 },
            data
          }
        ]
      }
    },

    disposeCharts () {
      if (this.heartChartInstance) this.heartChartInstance.dispose()
      if (this.breathingChartInstance) this.breathingChartInstance.dispose()
      this.heartChartInstance = null
      this.breathingChartInstance = null
    },

    renderChart () {
      this.disposeCharts()
      if (!this.series || !this.$refs.heartChart || !this.$refs.breathingChart) return
      const group = 'sni-report-vital-signs-h5'
      this.heartChartInstance = echarts.init(this.$refs.heartChart)
      this.breathingChartInstance = echarts.init(this.$refs.breathingChart)
      this.heartChartInstance.group = group
      this.breathingChartInstance.group = group
      this.heartChartInstance.setOption(this.chartOption('心率', '#d92d20', this.series.heartRate))
      this.breathingChartInstance.setOption(this.chartOption('呼吸频率', '#2779ff', this.series.respirationRate))
      echarts.connect(group)
    },

    resizeChart () {
      if (this.heartChartInstance) this.heartChartInstance.resize()
      if (this.breathingChartInstance) this.breathingChartInstance.resize()
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-vital-chart {
  width: 100%;

  &__grid {
    display: grid;
    gap: 10px;
  }

  &__panel {
    overflow: hidden;
    border: 1px solid #dce8f2;
    border-radius: 8px;
    background: #f8fcff;
  }

  h3 {
    margin: 0;
    padding: 9px 12px 0;
    color: #1a3f6a;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
  }

  &__canvas {
    width: 100%;
    height: 220px;
  }
}
</style>
